var newsletterSignup = {};

(function (newsletterSignupApp) {
	newsletterSignupApp.Submit = function () {
		$.ajax({
			url: "/umbraco/surface/NewsletterSignupSurface/Submit",
			type: "POST",
			data: $(".footer-signup").serialize(),
			dataType: "html",
			success: function (data) {
				$(".js-newsletter-signup").html(data);

				var recaptchaEl = $('.js-newsletter-signup .g-recaptcha');
				if (recaptchaEl.length) {
					grecaptcha.render(recaptchaEl[0],
						{
							'sitekey': recaptchaEl.data('sitekey')
						});
				}
			},
			error: function (error) {
				console.log(error);
			}
		});
	};

	$(document).ready(function () {
		$('body').on('click', '.js-newsletter-submit', function (e) {
			e.preventDefault();
			newsletterSignup.Submit();
		});
	});

})(newsletterSignup);
